import { render, staticRenderFns } from "./DialogCreateCompany.vue?vue&type=template&id=63c447f2&scoped=true"
import script from "./DialogCreateCompany.vue?vue&type=script&lang=js"
export * from "./DialogCreateCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c447f2",
  null
  
)

export default component.exports